import { Observable, fromEvent } from "rxjs";
import { throttleTime, map, filter } from "rxjs/operators";
import { CoreCOMService } from "../services/com.service";
import { Injectable } from "@angular/core";
import { EMenuService } from "../services/emenu.service";

/** ScrollHelper for infinityscroll */
@Injectable({
  providedIn: "root"
})
export class ScrollHelper {

  private scrollElement: string = "page";

  constructor(private _eMenuService: EMenuService) {
  }

  public getScrollElement(): HTMLElement {
    const me = this;
    if (me._eMenuService.isActive) {
      return document.body; // Emenu uses outerScroll
    } else {
      return document.getElementById(me.scrollElement);
    }
  }

  /** Creates a observer for the Content Element, to inform over loading next page, when the content is scrollt down and no enoth content for next site
   * @param elementId html element id for scrollcontent#
   * @returns distinct Observer boolean, to say next page is need or not
   */
  public InfiniteScrollObserver(): Observable<boolean> {
    const me = this;
    const scrollContentElement: HTMLElement = me.getScrollElement();
    return fromEvent(scrollContentElement, "scroll").pipe(
      throttleTime(10), // 10 ms for reduce evulating for performance
      map(() => scrollContentElement.scrollHeight - (scrollContentElement.scrollTop + window.innerHeight) < (window.innerHeight * 0.5)),
      filter(r => r)
    );
  }

  /**
   * smooth scroll an element base on offset to the top of the page.
   */
  public SmoothScroll(offset: number, scrollTop: number = 0): void {
    const me = this;
    const scrollContentElement: HTMLElement = me.getScrollElement();
    let step = 10;
    if (offset - scrollTop > -1) {
      setTimeout(() => {
        scrollContentElement.scrollTop = scrollTop;
        step = (offset - scrollTop < step && offset - scrollTop > 0) ? offset - scrollTop : step;
        me.SmoothScroll(offset, scrollTop + step);
      }, 2);
    }
  }

  /**
   * scroll Element to top an element base on offset to the top of the page.
   */
  public ScrollElementToTop(offset: number, scrollTop: number = 0): void {
    const me = this;
    const scrollContentElement: HTMLElement = me.getScrollElement();
    scrollContentElement.scrollTop = offset;
  }

}
